import { MainMobileMenuEffects } from './main-mobile-menu.effects';

export const effects: any[] = [MainMobileMenuEffects];
